import { FC, useEffect, useState } from "react"

import { Menu, MenuItem } from "../../../../../components/mui.components"
import { useAppDispatch } from "../../../../../core/app/hooks"
import { getCaseById } from "../../../../../core/app/slices/case"
import { UI_PERMISSION } from "../../../../../core/utils/access/permissionConstants"
import usePermissions from "../../../../../hooks/userPermission"
import {
  getBtnActionsByStatus,
  UNARCHIVEPATIENT,
} from "../../../config/menuAction.config"

import MenuIconButton from "./MenuIconButton"

const UTableActionCell: FC<{
  row: any
  hoverKey: number
  handleMouseOut: () => void
  tableName: string
  onMenuBtnClick: (actionType: string, row: any) => void
}> = ({ row, hoverKey, handleMouseOut, tableName, onMenuBtnClick }) => {
  const { doesNotHaveAny } = usePermissions()
  const dispatch = useAppDispatch()
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
  const [menuKey, setMenuKey] = useState<boolean>(false)
  const [actions, setActions] = useState([])

  const handleOnMenuIconClose = (event) => {
    event.stopPropagation()
    setAnchorEl(null)
    setMenuKey(false)
    handleMouseOut()
  }

  useEffect(() => {
    if (menuKey) {
      const updateMenuByPermissions = (actions: any) => {
        if (doesNotHaveAny(UI_PERMISSION.UI_TXPLANS_ARCHIVE)) {
          actions = actions.filter(
            (item) => item.btnAction !== "OPEN_CASE_ARCHI_MVEODEL",
          )
        }
        if (doesNotHaveAny(UI_PERMISSION.UI_TXPLANS_UNARCHIVE)) {
          actions = actions.filter(
            (item) => item.btnAction !== "OPEN_CASE_UNARCHIVE_MODEL",
          )
        }

        if (doesNotHaveAny(UI_PERMISSION.UI_PATIENTS_ARCHIVE)) {
          actions = actions.filter(
            (item) => item.btnAction !== "OPEN_ARCHIVE_PATIENT_MODEL",
          )
        }
        if (doesNotHaveAny(UI_PERMISSION.UI_PATIENTS_UNARCHIVE)) {
          actions = actions.filter(
            (item) => item.btnAction !== "OPEN_UNARCHIVE_PATIENT_MODEL",
          )
        }

        if (doesNotHaveAny(UI_PERMISSION.UI_TXPLANS_UPDATESTATUS)) {
          actions = actions.filter(
            (item) =>
              ![
                "UPDATE_STATUS_DELIVERED_TO_IN_PROGRESS",
                "UPDATE_STATUS_IN_PROGRESS_TO_COMPLETE",
              ].includes(item.btnAction),
          )
        }

        if (doesNotHaveAny(UI_PERMISSION.UI_TXPLANS_DOWNLOAD)) {
          actions = actions.filter(
            (item) => item.btnAction !== "DOWNLOAD_FILES",
          )
        }

        if (doesNotHaveAny(UI_PERMISSION.UI_UNLOCK_CASE)) {
          actions = actions.filter((item) => item.btnAction !== "UNLOCK_CASE")
        }

        if (doesNotHaveAny(UI_PERMISSION.UI_PATIENTS_CREATE)) {
          actions = actions.filter(
            (item) =>
              ![
                "OPEN_RECORDS",
                "OPEN_PRESCRIPTION_FORM",
                "OPEN_SUMMARY",
              ].includes(item.btnAction),
          )
        }

        if (doesNotHaveAny(UI_PERMISSION.UI_ORDERS_CREATEUASSIST)) {
          actions = actions.filter(
            (item) => !["START_REFINEMENT"].includes(item.btnAction),
          )
        }
        if (doesNotHaveAny(UI_PERMISSION.UI_ORDERS_CREATE)) {
          actions = actions.filter(
            (item) => !["OPEN_TREAT_PAGE"].includes(item.btnAction),
          )
        }

        return actions
      }
      if (row.objtype === "CASE") {
        const caseStatus = getBtnActionsByStatus(
          row.caseStatus?.status.key || row.caseDisposition,
          row.isInitialuAssist,
          row.isRefinementReady,
          !!(row.locked_by || row.locked_date),
        )
        if (caseStatus?.actions) {
          setActions([...updateMenuByPermissions(caseStatus.actions)])
        }
      } else {
        dispatch(
          getCaseById({ patientId: row.patientId, caseId: row.caseId }),
        ).then((res) => {
          if (res.payload) {
            const caseStatus = getBtnActionsByStatus(
              res.payload.caseDisposition,
              res.payload.isInitialuAssist,
              res.payload.isRefinementReady,
              !!(res.payload.locked_by || res.payload.locked_date),
            )

            if (caseStatus?.actions) {
              setActions([...updateMenuByPermissions(caseStatus.actions)])
            }
          }
        })
      }
    }
  }, [row, menuKey])

  return (
    <>
      {
        <MenuIconButton
          onClickHandler={(event) => {
            event.stopPropagation()
            setAnchorEl(event.currentTarget)
            setMenuKey(true)
          }}
          id={row.patientId}
          sxProps={{ justifyContent: "end" }}
          isSelected={!!menuKey}
        />
      }
      {menuKey && (row.status === "ARCHIVED" || actions.length > 0) && (
        <Menu
          id={`${row.patientId}-content`}
          aria-labelledby={`${row.patientId}-button`}
          sx={{
            ".MuiPaper-root": {
              minWidth: "220px",
            },
          }}
          open={menuKey}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          onClose={handleOnMenuIconClose}
        >
          {row.status === "ARCHIVED" ? (
            <MenuItem
              onClick={(event) => {
                event.stopPropagation()
                onMenuBtnClick &&
                  onMenuBtnClick(UNARCHIVEPATIENT.btnAction, row)
              }}
            >
              {UNARCHIVEPATIENT.btnText}
            </MenuItem>
          ) : (
            actions.map((btn, index) => (
              <MenuItem
                key={btn?.btnAction + "" + index}
                onClick={(event) => {
                  event.stopPropagation()
                  onMenuBtnClick && onMenuBtnClick(btn.btnAction, row)
                }}
              >
                {btn.btnText}
              </MenuItem>
            ))
          )}
        </Menu>
      )}
    </>
  )
}

export default UTableActionCell
